import { render, staticRenderFns } from "./FieldSection.vue?vue&type=template&id=32f0bbe6&scoped=true&name=field-section&"
import script from "./FieldSection.vue?vue&type=script&lang=js&"
export * from "./FieldSection.vue?vue&type=script&lang=js&"
import style0 from "./FieldSection.vue?vue&type=style&index=0&id=32f0bbe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f0bbe6",
  null
  
)

export default component.exports